import React, { useEffect, useState } from "react";
import {
  LineChart, Line, XAxis, YAxis, Tooltip,
  ResponsiveContainer, CartesianGrid,
  PieChart, Pie, Cell
} from "recharts";

export default function StrategyStatsCard({ strategyId }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`https://focifanatik.hu/api/strategy_statistics.php?strategy_id=${strategyId}`)
      .then(res => res.json())
      .then(data => setStats(data))
      .catch(err => console.error(err));
  }, [strategyId]);

  if (!stats) {
    return <p className="text-center text-muted">Statisztika betöltése...</p>;
  }

  const wins = Number(stats.summary.wins);
  const losses = Number(stats.summary.losses);

  const pieData = [
    { name: "Nyertes", value: wins },
    { name: "Vesztes", value: losses }
  ];

  const COLORS = ["#198754", "#dc3545"];

  return (
    <>
      {/* KPI */}
      <div className="row g-3 mb-4">
        <StatCard title="Összes tipp" value={stats.summary.total_bets} />
        <StatCard title="Találati arány" value={`${stats.summary.win_rate}%`} />
        <StatCard title="Profit" value={`${stats.summary.total_profit} Ft`} />
        <StatCard title="ROI" value={`${stats.summary.roi}%`} />
        <StatCard title="Széria" value={stats.streak} />
      </div>

      <div className="row g-4">
        {/* Profit timeline */}
        <div className="col-md-8">
          <div className="stat-box">
            <h6>📈 Profit alakulása</h6>
            <ResponsiveContainer width="100%" height={260}>
              <LineChart data={stats.timeline}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="profit"
                  stroke="#198754"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Win / Lose */}
        <div className="col-md-4">
          <div className="stat-box">
            <h6>⚖️ Win / Lose</h6>

            {wins + losses === 0 ? (
              <p className="text-center text-muted mt-5">
                Nincs még lezárt szelvény
              </p>
            ) : (
              <ResponsiveContainer width="100%" height={260}>
                <PieChart>
                  <Pie
                    data={pieData}
                    dataKey="value"
                    outerRadius={90}
                    label
                  >
                    {pieData.map((_, i) => (
                      <Cell key={i} fill={COLORS[i]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function StatCard({ title, value }) {
  return (
    <div className="col-6 col-md-2">
      <div className="stat-card">
        <small>{title}</small>
        <strong>{value}</strong>
      </div>
    </div>
  );
}
